export default "__VITE_ASSET__D8yXHqE7__"